import { Component, createEffect } from 'solid-js';
import { createQuery } from '@tanstack/solid-query';

import { assetProgressQuery, assetQuery } from '~/store/tanstack-query';
import { updateVodMediaMetadata } from '~/cast/VrioOtt';
import { CreateGetStreamedTime } from '~/utils/types';
import { getPlayerManager } from '~/cast/lib';

interface VodMetadataUpdaterProps {
  vrioAssetId: string;
  asset: {
    mainAssetId: string;
    vmsId: string;
    type: string;
  };
  streamedContentTime: CreateGetStreamedTime;
  onFinished: () => void;
}

export const VodMetadataUpdater: Component<VodMetadataUpdaterProps> = (
  props,
) => {
  const vrioAssetId = () => props.vrioAssetId;
  const vmsId = () => props?.asset?.vmsId ?? '';
  const assetType = () => props?.asset?.type ?? '';
  const mainAssetId = () => props?.asset?.mainAssetId ?? '';

  const query = createQuery(() => assetQuery(vrioAssetId()));
  const progressQuery = createQuery(() =>
    assetProgressQuery(vrioAssetId(), assetType(), vmsId(), mainAssetId()),
  );

  createEffect((prevIsPending) => {
    if (prevIsPending && !query.isPending) {
      props.onFinished();

      props.streamedContentTime?.reset();
      props.streamedContentTime?.start();
    }
  });

  createEffect((prev) => {
    const playerManager = getPlayerManager();

    const currentData = query.data;
    const progressData = progressQuery.data;

    // Change video progress based on the content last progress
    let currentProgress = 0;

    if (
      progressData &&
      'progress' in progressData &&
      typeof progressData.progress === 'number'
    ) {
      currentProgress = progressData.progress;
    }

    if (assetType() === 'EPISODE') {
      currentProgress =
        (
          progressData &&
          'contents' in progressData &&
          Array.isArray(progressData.contents)
        ) ?
          progressData.contents?.[0]?.vod?.progress ?? 0
        : 0;
    }

    playerManager.seek(currentProgress);

    if (!currentData || prev === currentData) return currentData;

    updateVodMediaMetadata(currentData);
    return currentData;
  });

  return undefined;
};
